import { defaultDayDisplay, isNull } from "App/utils/helpers";
import moment from "moment";

export const validUTC = (str) => {
  return isNull(str) ? "" : moment(str).utc().format();
};

export const startOfDay = (str) => {
  return isNull(str)
    ? ""
    : moment(`${moment(str).format("YYYY-MM-DD")}T00:00:00`)
        .utc()
        .format();
};

export const lastOfDay = (str) => {
  return isNull(str)
    ? ""
    : moment(`${moment(str).format("YYYY-MM-DD")}T23:59:59`)
        .utc()
        .format();
};

export const toFirstHoursDay = (str) => {
  const m = moment(str);
  m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  m.toISOString();

  return isNull(str) ? "" : m.format();
};

export const toLastHoursDay = (str) => {
  const m = moment(str);
  m.set({ hour: 23, minute: 59, second: 59 });
  m.toISOString();
  return isNull(str) ? "" : m.format();
};

export const endOfDay = (withTime = false) => {
  return withTime
    ? moment().endOf("day").local().format("YYYY-MM-DDTHH:mm")
    : moment().endOf("day").local().format("YYYY-MM-DD");
};

export const differentDayWithNow = (date) => {
  const start = Date.parse(moment().local().format("YYYY-MM-DDTHH:mm:ss"));
  const end = Date.parse(moment(date).local().format("YYYY-MM-DDTHH:mm:ss"));

  const different = start - end;

  const sec = different;
  const min = Math.round(different / 60000);
  const hour = Math.round(different / 3600000);
  const day = Math.round(different / 86400000);
  const week = Math.round(different / 604800000);
  const month = Math.round(different / 2419200000);
  // const year = Math.round(different / 29030400000);

  let times = "";

  if (sec <= 60) {
    times = sec + " detik yang lalu";
  } else if (min <= 60) {
    times = min + " menit yang lalu";
  } else if (hour <= 24) {
    times = hour + " jam yang lalu";
  } else if (day <= 7) {
    times = defaultDayDisplay(date);
  } else if (week <= 4) {
    times = defaultDayDisplay(date);
  } else if (month <= 12) {
    times = defaultDayDisplay(date);
  } else {
    times = defaultDayDisplay(date);
  }

  return times;
};

export const dateFormat = ({date, formatDate, withTime = true, utc = true}) => {
  if (isNull(date)) {
    return ""
  } else {
    if (utc) {
      const format = formatDate ? formatDate : withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"
      return moment(date).utc().local().format(format)
    } else {
      const format = formatDate ? formatDate : withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"
      return moment(date).parseZone().format(format)
    }
  }
}
